import { TFunction } from "i18next";
import { Fields } from "../types/SchemaFactory";
import { schemaFactory } from "./SchemaFactory";
import {
    PartnersFiltersValues,
    PartnersFormValues,
} from "../domain/models/Partners";

export const partnersFiltersFields: Fields<PartnersFiltersValues> = {
    title: {
        min: 2,
        max: 90,
        placeholderKey: "console.partners.table.title",
        type: "text",
        optional: true,
        initial: "",
    },
    description: {
        min: 2,
        max: 200,
        placeholderKey: "console.partners.table.description",
        type: "text",
        optional: true,
        initial: "",
    },
    creatorId: {
        min: 1,
        max: 50,
        placeholderKey: "console.partners.table.creatorId",
        type: "text",
        optional: true,
        initial: "",
    },
    isActive: {
        type: "checkbox",
        placeholderKey: "console.partners.table.isActive",
        optional: true,
        initial: true,
    },
};

export const partnersFields: Fields<PartnersFormValues> = {
    files: {
        type: "files",
        optional: true,
        initial: [],
    },
    translations: {
        objectArray: {
            title: {
                min: 2,
                max: 90,
                placeholderKey: "console.partners.table.title",
                type: "text",
                optional: false,
                initial: "",
            },
            description: {
                min: 2,
                max: 200,
                placeholderKey: "console.partners.table.description",
                type: "text",
                optional: false,
                initial: "",
            },
            // Fields that are set programmatically (not by the user)
            partnerId: {
                type: "hidden",
                optional: true,
                initial: "",
            },
            languageCode: {
                type: "hidden",
                optional: true,
                initial: "",
            },
        },
        initial: [],
    },
    isActive: {
        type: "checkbox",
        placeholderKey: "console.partners.table.isActive",
        optional: false,
        initial: true,
    },
    websiteUrl: {
        min: 2,
        max: 500,
        placeholderKey: "console.partners.table.websiteUrl",
        type: "text",
        optional: true,
        initial: "",
    },
};

export const partnersFiltersSchemaFactory = (t: TFunction) => {
    return schemaFactory(t, partnersFiltersFields);
};

export const partnersSchemaFactory = (t: TFunction) => {
    return schemaFactory(t, partnersFields);
};
